/**
 * Design tokens Salespetro — fonte de verdade para cores e espaçamento.
 * CSS: tokens.css (--sp-*). Ver docs/design-system.md
 */

export const tokens = {
  color: {
    navy: '#001A33',
    primary: '#003F91',
    primaryDark: '#002137',
    accent: '#FF770D',
    secondary: '#ff7f16',

    surfacePage: '#E8ECF0',
    surfaceCard: '#FFFFFF',
    surfaceInset: '#FAFBFC',
    /** Ant/legado `#F5F5F5` — fundos muted (não confundir com surface-page) */
    surfaceMuted: '#F5F5F5',
    /** Ant/legado `#FAFAFA` — superfícies muito claras */
    surfaceSubtle: '#FAFAFA',
    border: '#DDE3EA',
    /** Ant/legado `#D9D9D9` — bordas de input/tabela */
    borderMuted: '#D9D9D9',
    /** Ant/legado `#E8E8E8` — bordas mais suaves */
    borderSubtle: '#E8E8E8',
    /** Ant/legado `#F0F0F0` — divisores de linha / split */
    divider: '#F0F0F0',
    text: '#0F1724',
    /** AA-safe em surface-card e surface-page */
    textSecondary: '#4A5568',
    /**
     * Soft legado `#5C6B7A` (muito usado em CSS).
     * Distinto de textSecondary — migração 1:1 sem mudar cor no ecrã.
     */
    textSubtle: '#5C6B7A',
    /** Ant/legado `#666666` / `#666` — texto terciário */
    textMuted: '#666666',
    /** Ant/legado `#8C8C8C` — placeholder / hint */
    textPlaceholder: '#8C8C8C',

    variationUp: '#ff4d4f',
    variationDown: '#52c41a',
    /** AA-safe (WCAG ≥ 4.5:1 em #fff) — usar em texto/badges, não em séries de gráfico */
    variationUpText: '#c41b1c',
    variationDownText: '#2d7d09',

    warning: '#FFA500',
    error: '#ff4d4f',
    success: '#52c41a',
    info: '#003F91',

    background: '#E8ECF0',
    backgroundWhite: '#FFFFFF',
    backgroundSecondary: '#5A8FD6',
    fontPrimary: '#003F91',
    fontSecondary: '#90E0EF',
    fontWhite: '#FFFFFF',
    fontBlack: '#000000',
    borderLegacy: '#003f91',
    icon: '#FF770D',
    iconPrimary: '#003f91',
  },
  space: {
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    xxl: 32,
  },
  radius: {
    sm: 6,
    md: 10,
  },
  shadow: {
    card: '0 1px 2px rgba(0, 26, 51, 0.06), 0 8px 24px rgba(0, 26, 51, 0.08)',
  },
  font: {
    family: '"IBM Plex Sans", system-ui, sans-serif',
    familyMono: '"IBM Plex Mono", ui-monospace, monospace',
  },
} as const;

export type DesignTokens = typeof tokens;
